import React from 'react'

const FolderTick = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8996 3.49365L7.28711 10.1062L4.67461 7.4999L3.79336 8.38115L7.28711 11.8749L14.7871 4.3749L13.8996 3.49365ZM11.2496 4.3749L10.3684 3.49365L6.40586 7.45615L7.28711 8.3374L11.2496 4.3749ZM3.74961 11.8749L0.255859 8.38115L1.14336 7.4999L4.63086 10.9937L3.74961 11.8749Z"
        fill="#10AD7A"
      />
    </svg>
  )
}

export default FolderTick
